import script from "./AddEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddEdit.vue?vue&type=style&index=0&id=1dcc45fb&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\arm_analysis_2025_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dcc45fb"]])

export default __exports__